module.exports = __webpack_public_path__ + "img/logo_x_color.1516422b.svg";